import { render } from "./OapRoutineBuilder.vue?vue&type=template&id=5f3450cd"
import script from "./OapRoutineBuilder.vue?vue&type=script&lang=js"
export * from "./OapRoutineBuilder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__